import clubsPicked from '@assets/jackpot-cards/clubsPicked.png'
import diamondsPicked from '@assets/jackpot-cards/diamondsPicked.png'
import heartsPicked from '@assets/jackpot-cards/heartsPicked.png'
import jackpotCardsLogoLandscape from '@assets/jackpot-cards/jackpot-cards-logo-l.png'
import jackpotCardsLogoPortrait from '@assets/jackpot-cards/jackpot-cards-logo-p.png'
import panelClubsLandscape from '@assets/jackpot-cards/panel-clubs-l.png'
import panelClubsPortrait from '@assets/jackpot-cards/panel-clubs-p.png'
import panelDiamondsLandscape from '@assets/jackpot-cards/panel-diamonds-l.png'
import panelDiamondsPortrait from '@assets/jackpot-cards/panel-diamonds-p.png'
import panelHeartsLandscape from '@assets/jackpot-cards/panel-hearts-l.png'
import panelHeartsPortrait from '@assets/jackpot-cards/panel-hearts-p.png'
import panelSpadesLandscape from '@assets/jackpot-cards/panel-spades-l.png'
import panelSpadesPortrait from '@assets/jackpot-cards/panel-spades-p.png'
import smallSuitClubsFull from '@assets/jackpot-cards/small-suit-clubs-full.png'
import smallSuitClubs from '@assets/jackpot-cards/small-suit-clubs.png'
import smallSuitDiamondsFull from '@assets/jackpot-cards/small-suit-diamonds-full.png'
import smallSuitDiamonds from '@assets/jackpot-cards/small-suit-diamonds.png'
import smallSuitHeartsFull from '@assets/jackpot-cards/small-suit-hearts-full.png'
import smallSuitHearts from '@assets/jackpot-cards/small-suit-hearts.png'
import smallSuitSpadesFull from '@assets/jackpot-cards/small-suit-spades-full.png'
import smallSuitSpades from '@assets/jackpot-cards/small-suit-spades.png'
import spadesPicked from '@assets/jackpot-cards/spadesPicked.png'
import { GameType, JackpotSuits, ViewportType } from 'game-ui-types'
import { JackpotCardsConfigType } from './types'

const smallSuitPortraitTopY = 60
const smallSuitPortraitBottomY = 151
const smallSuitLandscapeY = 52
const smallSuitDesktopY = 68
const offset = 10

const jackpotCardsConfigFactory = (
    type: JackpotSuits = JackpotSuits.CLUBS,
    gameType: GameType
): JackpotCardsConfigType => ({
    [ViewportType.MOBILE_PORTRAIT]: {
        jackpotStatistics: {
            // padding: { top: 8, sides: 8 },
            topRowMargin: { bottom: 26 },
            panelOuter: {
                width: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 330 : 242,
                height: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 72 : 62,
                marginBetween: 0,
            },
            amountBox: {
                width: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 270 : 182,
                height: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 64 : 55,
                fontSize: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 52 : 46,
                leftSymbolPadding: 15,
                top: 4,
            },
            odometer: {
                winActiveTop: 5,
                fontSize: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 52 : 46,
                fontColor: '#ffffff',
                lineHeight: type === JackpotSuits.SPADES || type === JackpotSuits.HEARTS ? 64 : 59,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: -2,
                fontWeight: '700',
                fontSize: 16,
                fontColor: '#ffffff',
                lineHeight: 18,
            },
            currency: {
                paddingBottom: 0,
                right: 1,
                fontWeight: '700',
                fontSize: 18,
                fontColor: '#000000',
                lineHeight: 16,
                width: 12,
            },
        },
        // jackpotLogo: {
        //     top: 76,
        //     width: 262,
        // },
        images: {
            logo: jackpotCardsLogoPortrait,
            panel: {
                [JackpotSuits.CLUBS]: panelClubsPortrait,
                [JackpotSuits.DIAMONDS]: panelDiamondsPortrait,
                [JackpotSuits.HEARTS]: panelHeartsPortrait,
                [JackpotSuits.SPADES]: panelSpadesPortrait,
            }[type],
        },
        extended: {
            smallSuits: {
                dimensions: 30,
                positions: {
                    [JackpotSuits.CLUBS]: [
                        {
                            x: 625,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                        {
                            x: 679,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                        {
                            x: 733,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                    ],
                    [JackpotSuits.DIAMONDS]: [
                        {
                            x: 67,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                        {
                            x: 121,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                        {
                            x: 175,
                            y:
                                gameType === GameType.SLOT_CONFIG_E
                                    ? smallSuitPortraitBottomY - offset
                                    : smallSuitPortraitBottomY,
                        },
                    ],
                    [JackpotSuits.HEARTS]: [
                        { x: 557, y: smallSuitPortraitTopY },
                        { x: 635, y: smallSuitPortraitTopY },
                        { x: 713, y: smallSuitPortraitTopY },
                    ],
                    [JackpotSuits.SPADES]: [
                        { x: 87, y: smallSuitPortraitTopY },
                        { x: 165, y: smallSuitPortraitTopY },
                        { x: 243, y: smallSuitPortraitTopY },
                    ],
                }[type],
                images: {
                    fullSmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubsFull,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamondsFull,
                        [JackpotSuits.HEARTS]: smallSuitHeartsFull,
                        [JackpotSuits.SPADES]: smallSuitSpadesFull,
                    }[type],
                    emptySmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubs,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamonds,
                        [JackpotSuits.HEARTS]: smallSuitHearts,
                        [JackpotSuits.SPADES]: smallSuitSpades,
                    }[type],
                    pickedSuit: {
                        [JackpotSuits.CLUBS]: clubsPicked,
                        [JackpotSuits.DIAMONDS]: diamondsPicked,
                        [JackpotSuits.HEARTS]: heartsPicked,
                        [JackpotSuits.SPADES]: spadesPicked,
                    }[type],
                },
            },
        },
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        jackpotStatistics: {
            // padding: { top: 10, sides: 10 },
            panelOuter: {
                width: 260,
                height: 62,
                marginBetween: type === JackpotSuits.DIAMONDS || type === JackpotSuits.HEARTS ? 10 : 0,
            },
            amountBox: {
                width: 200,
                height: 56,
                fontSize: 38,
                leftSymbolPadding: 14,
                top: 3,
            },
            odometer: {
                winActiveTop: 2,
                fontSize: 38,
                fontColor: '#ffffff',
                lineHeight: 61,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: -1,
                fontWeight: '700',
                fontSize: 16,
                fontColor: '#ffffff',
                lineHeight: 18,
            },
            currency: {
                paddingBottom: 0,
                right: 1,
                fontWeight: '700',
                fontSize: 18,
                lineHeight: 16,
                fontColor: '#000000',
                width: 12,
            },
        },
        // jackpotLogo: {
        //     top: 20,
        //     width: 365,
        // },
        images: {
            logo: jackpotCardsLogoLandscape,
            panel: {
                [JackpotSuits.CLUBS]: panelClubsLandscape,
                [JackpotSuits.DIAMONDS]: panelDiamondsLandscape,
                [JackpotSuits.HEARTS]: panelHeartsLandscape,
                [JackpotSuits.SPADES]: panelSpadesLandscape,
            }[type],
        },
        extended: {
            smallSuits: {
                dimensions: 30,
                positions: {
                    [JackpotSuits.CLUBS]: [
                        { x: 1246, y: smallSuitLandscapeY },
                        { x: 1300, y: smallSuitLandscapeY },
                        { x: 1354, y: smallSuitLandscapeY },
                    ],
                    [JackpotSuits.DIAMONDS]: [
                        { x: 976, y: smallSuitLandscapeY },
                        { x: 1030, y: smallSuitLandscapeY },
                        { x: 1084, y: smallSuitLandscapeY },
                    ],
                    [JackpotSuits.HEARTS]: [
                        { x: 346, y: smallSuitLandscapeY },
                        { x: 400, y: smallSuitLandscapeY },
                        { x: 454, y: smallSuitLandscapeY },
                    ],
                    [JackpotSuits.SPADES]: [
                        { x: 76, y: smallSuitLandscapeY },
                        { x: 130, y: smallSuitLandscapeY },
                        { x: 184, y: smallSuitLandscapeY },
                    ],
                }[type],
                images: {
                    fullSmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubsFull,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamondsFull,
                        [JackpotSuits.HEARTS]: smallSuitHeartsFull,
                        [JackpotSuits.SPADES]: smallSuitSpadesFull,
                    }[type],
                    emptySmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubs,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamonds,
                        [JackpotSuits.HEARTS]: smallSuitHearts,
                        [JackpotSuits.SPADES]: smallSuitSpades,
                    }[type],
                    pickedSuit: {
                        [JackpotSuits.CLUBS]: clubsPicked,
                        [JackpotSuits.DIAMONDS]: diamondsPicked,
                        [JackpotSuits.HEARTS]: heartsPicked,
                        [JackpotSuits.SPADES]: spadesPicked,
                    }[type],
                },
            },
        },
    },
    [ViewportType.DESKTOP]: {
        jackpotStatistics: {
            // padding: { top: 15, sides: 10 },
            panelOuter: {
                width: 347,
                height: 83,
                marginBetween: type === JackpotSuits.DIAMONDS || type === JackpotSuits.HEARTS ? 12 : 0,
            },
            amountBox: {
                width: 260,
                height: 74,
                fontSize: 48,
                leftSymbolPadding: 20,
                top: 4,
            },
            odometer: {
                winActiveTop: 4,
                fontSize: 51,
                fontColor: '#ffffff',
                lineHeight: 77,
                fontWeight: '900',
                digitWidthPadding: 3,
                spaces: {
                    width: 8,
                },
            },
            winningUser: {
                top: -1,
                fontWeight: '700',
                fontSize: 22,
                fontColor: '#ffffff',
                lineHeight: 24,
            },
            currency: {
                paddingBottom: 0,
                right: 1,
                fontWeight: '700',
                fontSize: 24,
                lineHeight: 21,
                fontColor: '#000000',
                width: 17,
            },
        },
        // jackpotLogo: {
        //     top: 25,
        //     width: 496,
        // },
        images: {
            logo: jackpotCardsLogoLandscape,
            panel: {
                [JackpotSuits.CLUBS]: panelClubsLandscape,
                [JackpotSuits.DIAMONDS]: panelDiamondsLandscape,
                [JackpotSuits.HEARTS]: panelHeartsLandscape,
                [JackpotSuits.SPADES]: panelSpadesLandscape,
            }[type],
        },
        extended: {
            smallSuits: {
                dimensions: 40,
                positions: {
                    [JackpotSuits.CLUBS]: [
                        { x: 1661, y: smallSuitDesktopY },
                        { x: 1733, y: smallSuitDesktopY },
                        { x: 1805, y: smallSuitDesktopY },
                    ],
                    [JackpotSuits.DIAMONDS]: [
                        { x: 1302, y: smallSuitDesktopY },
                        { x: 1374, y: smallSuitDesktopY },
                        { x: 1444, y: smallSuitDesktopY },
                    ],
                    [JackpotSuits.HEARTS]: [
                        { x: 461, y: smallSuitDesktopY },
                        { x: 533, y: smallSuitDesktopY },
                        { x: 604, y: smallSuitDesktopY },
                    ],
                    [JackpotSuits.SPADES]: [
                        { x: 101, y: smallSuitDesktopY },
                        { x: 173, y: smallSuitDesktopY },
                        { x: 245, y: smallSuitDesktopY },
                    ],
                }[type],
                images: {
                    fullSmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubsFull,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamondsFull,
                        [JackpotSuits.HEARTS]: smallSuitHeartsFull,
                        [JackpotSuits.SPADES]: smallSuitSpadesFull,
                    }[type],
                    emptySmallSuit: {
                        [JackpotSuits.CLUBS]: smallSuitClubs,
                        [JackpotSuits.DIAMONDS]: smallSuitDiamonds,
                        [JackpotSuits.HEARTS]: smallSuitHearts,
                        [JackpotSuits.SPADES]: smallSuitSpades,
                    }[type],
                    pickedSuit: {
                        [JackpotSuits.CLUBS]: clubsPicked,
                        [JackpotSuits.DIAMONDS]: diamondsPicked,
                        [JackpotSuits.HEARTS]: heartsPicked,
                        [JackpotSuits.SPADES]: spadesPicked,
                    }[type],
                },
            },
        },
    },
})

export const jackpotCardsConfig = (gameType: GameType) => ({
    [JackpotSuits.CLUBS]: jackpotCardsConfigFactory(JackpotSuits.CLUBS, gameType),
    [JackpotSuits.DIAMONDS]: jackpotCardsConfigFactory(JackpotSuits.DIAMONDS, gameType),
    [JackpotSuits.HEARTS]: jackpotCardsConfigFactory(JackpotSuits.HEARTS, gameType),
    [JackpotSuits.SPADES]: jackpotCardsConfigFactory(JackpotSuits.SPADES, gameType),
})

export const defaultJackpotCardsConfig = jackpotCardsConfigFactory(JackpotSuits.CLUBS, GameType.SLOT_CONFIG_A)
